import { getLink } from "../../../utils/utils";

import author from "./author";

const content = {
	esp: (
		`
		<p class="mb-2">
			Kompilis tiun libron Nikolao Gudskov, kiu, krom havi multajn titolojn en Esperantujo, estas ankaŭ biologo laŭ profesia klero. 
			La du ĉefokupoj, du sindediĉoj feliĉe koincidis en ĉi-libro; kaj jen antaŭ ni altnivele verkita scienc-populara libro, en perfekta Esperanto liveranta perfekte aŭtentajn sciojn pri ĉ. 50 specioj de diversaj mamuloj, de katoj ĝis kojpoj, de pinglomusoj ĝis elefantoj.
		</p>
		
		<p class="mb-2">
			Por ĉiu besto estas priskribita la historio de ĝia genro kaj specio, ekstera aspekto (kun precizaj korpodimensioj), skizo de la karakteriza por la besto konduto, rekomendoj pri konvenaj kondiĉoj de hejma tenado: kaĝo, manĝaĵo, temperatura kaj luma reĝimo, bredado ktp. 
			Priskribon de ĉiu specio akompanas bildeto, kiu montras la prezentatan beston en ĝia natura medio. 
			Krome, la plej ampleksaj ĉapitroj, tiuj pri katoj kaj hundoj, estas liveritaj de enhavoriĉaj rakontoj kun scivolindaj faktoj kaj bildoj, kiuj temas pri historio, sensoj, konduto, reproduktiĝo ktp, kaj ankaŭ utilaj informoj pri dresado, tenado de idoj kaj plenkreskaj bestoj, kaj eĉ informo pri internaciaj bredistaj asocioj. 
			Kaj foj-de-foje, kiel piednotoj, aperas spritaj kaj trafaj rimarkoj de la aŭtoro pri tiu aŭ alia temo.
		</p>
		
		<p class="mb-2">
			Do, la libron oni povas legi ne nur kiel informilon, sed simple kiel interesan legaĵon, inicantan onin al la mirinda mondo de vivaj estaĵoj. 
			Ja ĝuste tia devas esti bona scienc-populara libro: interesveka, kaŭzanta pli profundan komprenon kaj eĉ amon al sia objekto. 
			Ne lastas ankaŭ la lingvaĵo: ĝi devas esti simpla kaj klara. 
			Nu, la fama aktivulo certe plenumas tiun kondiĉon; sed gravas, ke en la libro per tiu facila lingvaĵo estas donata pure scienca informo. 
			En la prefaco la aŭtoro klarigas sian elekton de specialaj terminoj, kiu elekto en si mem estas sufiĉe malfacila kaj komplika afero, konsiderante nian ne tre evoluintan zoologian nomenklaturon. 
			Ofte la bezonata vorto eĉ tute ne ekzistas, kaj tiam la aŭtoro devas inventi kaj proponi ĝin mem. 
			Ni supozas, ke la pridiskutata libro alportos sian kontribuon ankaŭ al tiu pure scienca branĉo de esperantologio, kiu estas speciala nomenklaturo.
		</p>
		
		<p class="mb-2">
			Sed se paroli pri laikoj, simplaj posedantoj de diversaj hejmaj bestoj, por kiuj estas destinita tiu ĉi libro, same kiel aliuj libroj de la serio «familia biblioteko», do por ili utilos, krom specifaj donitaĵoj, ankaŭ ĝeneralaj ĉapitroj: «Kiaj mamuloj loĝas en hejmoj kaj kiel elekti hejman dorlotbeston», «Zorgado pri hejmaj mamuloj», Transportado, Zoohigieno, Nutraĵo, Koprofagio, Malsanoj kaj kuraco ktp. 
			Kolosa laboro estis farita por trovi tiujn dise lokitajn informojn kaj krei el ili klaran kaj koncizan tekston. 
			Pro tio la libro povas servi al ajna bestposedanto, kiu trovos en ĝi amason da utila informo.
		</p>
		
		<p class="mb-2">
			En la fino de la libro troviĝas «Kvinlingva (sed fakte 6-lingva!) listo de bestnomoj kaj taksonomiaj unuoj» en la lingvoj Esperanto, latina (scienca), angla, franca, germana kaj rusa. 
			Tiu indekso faras la libron facile uzebla por ajnalingvano, ĉu profesia biologo, ĉu simple bestamanto, kiuj multegas en nia Esperantujo.
		</p>
		
		<p class="mb-2">
			Sur la lastaj paĝoj troviĝas Tabelo de karakterizaj trajtoj de la priskribitaj specioj, kiu enhavas, i.a., kariotopon, dentan formulon, longecon de la korpo kaj de la vosto, vivodaŭron, averaĝan kvanton da idoj kaj gravedperiodon. 
			Tiuj donitaĵoj estas dismetitaj en pluraj sciencaj fontoj, kaj kunigi ilin kaj ordigi en klara komprenebla tabelo ankaŭ estas merito de la aŭtoro.
		</p>
		
		<p class="mb-2">
			Kaj fine – pri la aspekto de la libro. 
			Ĝi estas eldonita en 2008 de la Moskva eldonejo «Impeto» en la serio «familia biblioteko». 
			Eldonado de tiu serio komenciĝis en 2007 per «Ilustrita enciklopedio de akvariaj fiŝoj». 
			Ambaŭ libroj estas eldonitaj tre zorgeme, sen eraroj (kio tre maloftas!), sur bona blanka papero, kun multaj nigra-blankaj bildetoj ene kaj koloraj sur duonmola kovrilo. 
			La libroj aspektas alloge kaj indas librobretojn de ĉiuj leg-, best- kaj Esperant-amantoj.
		</p>
		`
	)
}

const itemName = {
	esp: 'Kolosa Laboro (pri «Ilustrita Enciklopedio de hejmaj mamuloj» de N. Gudskov)'
}

const itemBookInfo = {
	esp: {
		bookName: 'Ilustrita Enciklopedio de hejmaj mamuloj',
		content: `
			<p>
				Aŭtoro: N. Gudskov, <br/>
				Moskvo, Impeto, 2008, 240 p.
			</p>
		`
	}
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemAuthor: author.esp,
		itemBookInfo: itemBookInfo.esp,
	}
}

export default item;

